import { useTheme } from "../../../CommonComponents/ThemeProvider";
import React from "react";
import { formatPrice } from "../../utils/FormatPrice";

/**
 * QuickCashButtons
 * - Renders a set of quick cash buttons
 * - Calls onSelect with the value when a button is clicked
 */
export default function QuickCashButtons({ values, onSelect }) {
    const { currentTheme } = useTheme();
    return (
        <div className="flex gap-1 mb-2 w-full justify-between">
            {values.map((value) => (
                <div key={value} className="relative group flex-1">
                    <button
                        type="button"
                        onClick={() => onSelect(value)}
                        className="w-full px-1.5 py-0.5 rounded-full bg-white border border-gray-300 shadow-sm text-xs font-semibold text-gray-700 transition focus:outline-none min-w-0 hover:bg-gray-100 active:bg-gray-200"
                        style={{
                            boxShadow: undefined,
                            borderColor: undefined,
                            outline: undefined,
                            outlineColor: undefined,
                        }}
                        // Use inline style for focus ring color
                        onFocus={e => e.target.style.boxShadow = `0 0 0 2px ${currentTheme.color}`}
                        onBlur={e => e.target.style.boxShadow = ''}
                    >
                        {formatPrice(value)}
                    </button>
                    <span className="absolute left-1/2 -translate-x-1/2 bottom-full mb-2 w-max px-2 py-1 rounded bg-black text-white text-xs opacity-0 group-hover:opacity-100 pointer-events-none transition-opacity z-10 whitespace-nowrap">
                        {`Add ${formatPrice(value)} for quick cash`}
                    </span>
                </div>
            ))}
        </div>
    );
}
